import { render } from "./EditProduit.vue?vue&type=template&id=4687ecba&ts=true"
import script from "./EditProduit.vue?vue&type=script&lang=ts"
export * from "./EditProduit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__